import { render, staticRenderFns } from "./WapRegisterDevice2.vue?vue&type=template&id=556a8106&scoped=true&"
import script from "./WapRegisterDevice2.vue?vue&type=script&lang=js&"
export * from "./WapRegisterDevice2.vue?vue&type=script&lang=js&"
import style0 from "./WapRegisterDevice2.vue?vue&type=style&index=0&id=556a8106&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556a8106",
  null
  
)

export default component.exports